"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleFilter = exports.RadioTypes = exports.TVTypes = exports.AFMTypes = exports.ExtraTypes = exports.OffCameraPrincipalTypes = exports.OnCameraPrincipalTypes = exports.RoleScale = exports.RoleType = void 0;
const role_performer_types_1 = require("./role-performer-types");
/**
 * Role Type
 */
var RoleType;
(function (RoleType) {
    RoleType["Actor"] = "Actor";
    RoleType["Speaker"] = "Speaker";
    RoleType["Narrator"] = "Narrator";
    RoleType["Announcer"] = "Announcer";
    RoleType["Singer"] = "Singer";
    RoleType["SpecialtyDancer"] = "Specialty Dancer";
    RoleType["SpecialtyAct"] = "Specialty Act";
    RoleType["Puppeteer"] = "Puppeteer";
    RoleType["StuntPerformer"] = "Stunt Performer";
    RoleType["StuntCoordinator"] = "Stunt Coordinator";
    RoleType["Pilot"] = "Pilot";
    RoleType["Clown"] = "Clown";
    RoleType["StandIn"] = "Stand In";
    RoleType["HandModel"] = "Hand Model";
    RoleType["HandModelDoubleScale"] = "Hand Model Double Scale";
    RoleType["Other"] = "Other";
    RoleType["LeaderArrangerComposer"] = "Leader Arranger Composer";
    RoleType["CopyistSideMusician"] = "Copyist Side Musician";
    RoleType["CopyistSideMusician1Double"] = "Copyist Side Musician 1 Double";
    RoleType["CopyistSideMusician2Doubles"] = "Copyist Side Musician 2 Doubles";
    RoleType["CopyistSideMusician3Doubles"] = "Copyist Side Musician 3 Doubles";
    RoleType["CopyistSideMusician4Doubles"] = "Copyist Side Musician 4 Doubles";
})(RoleType || (exports.RoleType = RoleType = {}));
var RoleScale;
(function (RoleScale) {
    RoleScale["SessionScale"] = "Session Scale";
    RoleScale["AboveScale"] = "Above Scale";
})(RoleScale || (exports.RoleScale = RoleScale = {}));
/**
 * Type Lists
 */
exports.OnCameraPrincipalTypes = [
    RoleType.Actor,
    RoleType.Singer,
    RoleType.SpecialtyDancer,
    RoleType.SpecialtyAct,
    RoleType.StuntPerformer,
    RoleType.Pilot,
    RoleType.Clown,
];
exports.OffCameraPrincipalTypes = [
    RoleType.Narrator,
    RoleType.Announcer,
    RoleType.Puppeteer,
    RoleType.StuntCoordinator,
];
exports.ExtraTypes = [
    role_performer_types_1.RolePerformerType.Extra,
    RoleType.Actor,
    RoleType.StandIn,
    RoleType.Singer,
    RoleType.HandModel,
    RoleType.HandModelDoubleScale,
    RoleType.SpecialtyDancer,
    RoleType.SpecialtyAct,
    RoleType.StuntPerformer,
    RoleType.Pilot,
    RoleType.Clown,
];
exports.AFMTypes = [
    RoleType.LeaderArrangerComposer,
    RoleType.CopyistSideMusician,
    RoleType.CopyistSideMusician1Double,
    RoleType.CopyistSideMusician2Doubles,
    RoleType.CopyistSideMusician3Doubles,
    RoleType.CopyistSideMusician4Doubles,
];
exports.TVTypes = [
    ...exports.OnCameraPrincipalTypes,
    ...exports.OffCameraPrincipalTypes,
    ...exports.ExtraTypes,
    ...exports.AFMTypes,
];
exports.RadioTypes = [
    RoleType.Announcer,
    // ...AFMTypes // this line was in the client's version
];
/**
 * All Role/Performer Types
 */
exports.RoleFilter = {
    [role_performer_types_1.RolePerformerType.OnCameraPrincipal]: exports.OnCameraPrincipalTypes,
    [role_performer_types_1.RolePerformerType.OnCameraGroup]: exports.OnCameraPrincipalTypes,
    [role_performer_types_1.RolePerformerType.OffCameraPrincipal]: exports.OffCameraPrincipalTypes,
    [role_performer_types_1.RolePerformerType.OffCameraGroup]: exports.OffCameraPrincipalTypes,
    [role_performer_types_1.RolePerformerType.Extra]: exports.ExtraTypes,
    [role_performer_types_1.RolePerformerType.Radio]: exports.RadioTypes,
    [role_performer_types_1.RolePerformerType.AFM]: exports.AFMTypes,
};
//# sourceMappingURL=role-types.js.map